<template>
  <el-form ref="form" :model="form" class="form_flex">
    <el-form-item prop="userName">
      <el-input
        class="search-input"
        v-model="form.userName"
        placeholder="请输入用户名"
        @blur="onBlur"
      ></el-input>
    </el-form-item>
    <el-form-item prop="searchValue">
      <el-input
        class="search-input"
        v-model="form.mobile"
        placeholder="请输入手机号"
        @blur="onBlur"
      ></el-input>
    </el-form-item>

    <el-form-item class="btn">
      <el-button @click="onSearch" icon="el-icon-search" size="small"
        >查询</el-button
      >
      <el-button size="small" icon="el-icon-plus" @click="resetForm('form')"
        >清空</el-button
      >
      <el-button size="small" @click="onRefresh" icon="el-icon-refresh"
        >刷新</el-button
      >
    </el-form-item>
    <div>
      <el-button-group>
        <PermissionsBtn
          :icon="'el-icon-download'"
          :btnType="'primary'"
          :permissionName="'_Export'"
          :downloadUrl="'/userAdmin/Money/downLoad'"
          :checkList="checkList"
          :form="exportForm"
        ></PermissionsBtn>
      </el-button-group>
    </div>
  </el-form>
</template>

<script>
import { encrypt } from '@/utils/encryp';

export default {
  name: 'UserMoneyBar',
  // 与 layout 组件配合使用 provide / inject组合
  inject: ['reload'], // 注入reload方法
  props: {
    checkList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      form: {
        userName: '',
        mobile: '',
      },
      exportForm: {
        userName: '',
        mobile: '',
      },
    };
  },
  methods: {
    // 搜索
    onSearch() {
      let { userName, mobile } = this.form;
      let obj = {
        userName: userName ? encrypt(userName) : '',
        mobile: mobile ? encrypt(mobile) : '',
      };
      this.$parent.fetchData(obj);
    },

    // 失去焦点
    onBlur() {
      let { userName, mobile } = this.form;
      this.exportForm = {
        userName: userName ? encrypt(userName) : '',
        mobile: mobile ? encrypt(mobile) : '',
      };
    },

    // 清空表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.form = {
        userName: '',
        mobile: '',
      };
    },

    // 刷新当前页面
    onRefresh() {
      this.reload();
    },
  },
};
</script>

<style lang="less" scoped>
.form_flex {
  display: flex;
}

.search-input {
  margin: 0 10px;
  width: 170px;
}

.search-select1 {
  width: 120px;
}
.select {
  margin-right: 10px;
}

button {
  height: 40px;
  margin-left: 10px;
}

/deep/ .el-form-item__content {
  display: flex;
}
</style>
